module.exports = __webpack_public_path__ + "static/media/Gallery-7.5d8c1796.jpg";